module.exports = __webpack_public_path__ + "img/selling_point_cover_bck.75a69ed3.jpg";